module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-m-500.6da2c6d0c3ced2eb.jpg"+" 500w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-m-500.6da2c6d0c3ced2eb.jpg",width: 500,height: 411}],
        src: "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-m-500.6da2c6d0c3ced2eb.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniff-seo-bg-header-m-500.6da2c6d0c3ced2eb.jpg"},
        
        width: 500,
        height: 411
      }